// Thin intonation slide vs the nearest note, shown while an exercise runs.
export const TuningSlide = ({ pitch, testid = 'tuning-slide' }) => {
  const cents = pitch ? Math.max(-50, Math.min(50, pitch.cents)) : 0;
  const inTune = pitch && Math.abs(pitch.cents) <= 5;
  return (
    <div data-testid={testid} className="w-full max-w-sm flex items-center gap-3 animate-in fade-in slide-in-from-top-1 duration-300">
      <span data-testid={`${testid}-note`} className={`w-12 font-bebas text-2xl leading-none ${!pitch ? 'text-white/20' : inTune ? 'text-emerald-300' : 'text-white'}`}>
        {pitch ? `${pitch.note}${pitch.octave}` : '--'}
      </span>
      <div className="relative flex-1 h-3 rounded-full bg-[#0A0A0A] border border-white/10 overflow-hidden">
        <div className="absolute left-1/2 -translate-x-1/2 inset-y-0 w-[10%] bg-emerald-400/15" />
        <div className="absolute left-1/2 inset-y-0 w-px bg-emerald-400/60" />
        <div
          data-testid={`${testid}-needle`}
          className={`absolute inset-y-0 w-2 -ml-1 rounded-full transition-[left,background-color] duration-100 ease-out ${!pitch ? 'bg-white/15' : inTune ? 'bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.9)]' : 'bg-pink-400'}`}
          style={{ left: `${50 + cents}%` }}
        />
      </div>
      <span data-testid={`${testid}-cents`} className="w-14 text-right font-mono text-xs text-white/60">
        {pitch ? `${pitch.cents > 0 ? '+' : ''}${pitch.cents} c` : '— c'}
      </span>
    </div>
  );
};
